<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import FormatVerticalAlignTopIcon from 'vue-material-design-icons/FormatVerticalAlignTop.vue'
import scrollUtil from '@/utilities/scrollUtil'

const BUTTON_ACTIVATE_POSITION = 500

export default defineComponent({
  name: 'ScrollToPageTop',

  components: {
    FormatVerticalAlignTopIcon,
  },

  setup() {
    const isShow = ref(false)

    onMounted(() => {
      // 初期表示設定
      if (scrollUtil.getScrollY() > BUTTON_ACTIVATE_POSITION) {
        isShow.value = true
      }
    })

    // スクロールイベントによるボタンの表示制御
    const cleanupScroll = scrollUtil.throttle({
      callback: (e = {
        updateScrollPos: 0,
      }) => {
        isShow.value = !!e.updateScrollPos && e.updateScrollPos > BUTTON_ACTIVATE_POSITION
      },
      wait: 30,
    })

    onBeforeUnmount(() => {
      cleanupScroll()
    })

    return {
      isShow,
    }
  }
})
</script>

<template>
  <div
    :class="[
      'o-action__scrollToPageTop',
      { 'is-active': isShow },
      'u-action__tooltip',
    ]"
    data-tooltip="一番上へ戻る">
    <button
      v-scroll-to="'.f-container'"
      class="o-action__scrollToPageTop--item">
      <FormatVerticalAlignTopIcon />
    </button>
  <!-- /.o-action__scrollToPageTop --></div>
</template>

<style lang="sass" scoped>
$button-size: 50px
$icon-size: 24px

// object
.o-action__scrollToPageTop
  position: fixed
  bottom: 120px
  right: 20px
  visibility: hidden
  opacity: 0
  +transition($duration: $transition-long)

  &.is-active
    visibility: visible
    opacity: 1

  +mouseover
    z-index: 2

  & &--item
    width: $button-size
    height: $button-size
    display: block
    position: relative
    overflow: hidden
    color: rgba($font-white, 1)
    white-space: nowrap
    padding: math.div(($button-size - $icon-size), 2)
    background-color: rgba(#666, 0.7)
    box-shadow: 0 10px 20px rgba($bg-black, 0.19), 0 6px 6px rgba($bg-black, 0.23)
    border-radius: 50%
    +transition($duration: $transition-middle)

    +mouseover
      transform: scale(1.1)
      background-color: rgba(#2a2a2a, 0.7)

    > .material-design-icon
      +transition($duration: $transition-middle)

  +breakpoint($max-media: tablet)
    display: none
</style>
